module.exports = __webpack_public_path__ + "61bb03661fef9bf64bf92b3d93cd07d4.png";